<template>
  <div>
    <cm-activation-popup></cm-activation-popup>

    <cm-payments-popups></cm-payments-popups>
  </div>
</template>

<script>
import ActivationPopup from './CMServiceActivation.vue'

import PaymentsPopups from './payments/Popups.vue'

export default {
  name: 'cm-service-popups',
  components: {
    'cm-activation-popup': ActivationPopup,

    'cm-payments-popups': PaymentsPopups
  }
}
</script>
